export default __webpack_public_path__ + "static/media/deleteBinIcon.5bec2415.svg";